import {Box, IconButton, Menu, styled, Tooltip} from "@mui/material";
import React, {useState} from "react";
import {getIcon} from "../../helpers/getIcon";
import {getIconTitle} from "../../helpers/getIconTitle";
import {FactorInterface} from "../../interfaces/FactorInterface";
import {StyledTitleSmall} from "./AIMenuAnalytics";
import Article from "./Article";

interface FactorElInterface {
    color: string;
    article: FactorInterface;
}

const FactorContainer = styled(Box)({
    borderRadius: "100%",
});

const FactorMenuContainer = styled(Box)({
    width: "500px",
    height: "auto",
    padding: "10px",
    "@media(max-width: 768px)":{
        width: "calc(100vw - 48px)!important",
    }
});

const Factor = ({article, color}: FactorElInterface):JSX.Element => {
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLAnchorElement | HTMLButtonElement>(null);
    
    return (
        <FactorContainer
            sx={{
                border: "1px dashed " + color
            }}
        >
            <Tooltip title={getIconTitle(article.type)}>
                <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                    {getIcon(article.type)}
                </IconButton>
            </Tooltip>
            <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                <FactorMenuContainer>
                    <StyledTitleSmall>
                        A Brief Summary of the Original Article
                    </StyledTitleSmall>
                    <Article
                        title={article.title}
                        text={article.text}
                        type={article.type}
                        source={article.source}
                    />
                </FactorMenuContainer>
            </Menu>
        </FactorContainer>
    );
};

export default Factor;
